import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { contentListItem } from "../util";
import type { Swiper } from "swiper";
import { Observable } from "rxjs";

@Component({
    selector: "app-callout-group",
    templateUrl: "./callout-group.component.html",
    styleUrls: ["./callout-group.component.scss"],
    standalone: false
})
export class CalloutGroupComponent implements OnInit {
  @Input() items: Observable<contentListItem[]>;
  swiper: Swiper;
  groupNumbers: boolean[];
  length = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  onSwiper(ev: CustomEvent) {
    this.swiper = ev.detail[0];
    this.swiper.on("slideChange", () => this.cdr.detectChanges());
  }
  navigateTo(i: number) {
    this.swiper.slideTo(i);
  }
  ngOnInit(): void {
    this.items.subscribe((items: contentListItem[]) => {
      this.length = items.length;
      let len = items.length;
      this.groupNumbers = items
        .map(() => true)
        .slice(0, (len % 2 == 0 ? len : len + 1) / 2);
    });
  }

  getColor(i: number) {
    switch (i % 3) {
      case 0:
        return "primary";
      case 1:
        return "secondary";
      case 2:
        return "tertiary";
    }
  }
  getSide(i: number) {
    let len = this.length;
    return i >= (len % 2 == 0 ? len : len + 1) / 2 ? "right" : "left";
  }
}
